/* tslint:disable:component-selector */
import { Component, HostBinding, Input } from '@angular/core';

import { LoaderButtonState } from '../../button/button-status';

@Component({
  selector: '[loader-button]',
  templateUrl: './loader-button.component.html'
})
export class LoaderButtonComponent {
  @HostBinding('class.c-loader-button')
  public useLoaderClass = true;
  @HostBinding('class.c-loader-button--loading')
  public isLoading = false;
  @HostBinding('class.c-loader-button--done')
  public hasDone = false;
  @HostBinding('class.c-loader-button--failed')
  public hasFailed = false;

  @Input()
  public set state(state: LoaderButtonState) {
    switch (state) {
      case LoaderButtonState.DONE:
        this.hasDone = true;
        this.isLoading = false;
        this.hasFailed = false;
        setTimeout(() => (this.state = LoaderButtonState.NONE), 5000);
        break;
      case LoaderButtonState.FAILED:
        this.hasDone = false;
        this.isLoading = false;
        this.hasFailed = true;
        break;
      case LoaderButtonState.LOADING:
        this.hasDone = false;
        this.isLoading = true;
        this.hasFailed = false;
        break;
      default:
        this.hasDone = false;
        this.isLoading = false;
        this.hasFailed = false;
    }
  }
}
